import { get } from '@/api'

/**
 * Fetch annotations for a specific record
 * @param {Object} options Options containing appName, modelName and id
 * @param {URLSearchParams} params URL parameters (defaults to max page_size)
 * @returns {Promise<Array>} Array of annotation objects
 */
export async function fetchRecordAnnotations(
  { appName, modelName, id } = {},
  params = new URLSearchParams({ page_size: 'max' }),
) {
  let annotations = []
  const fetchAnnotUrl = [
    `${appName}/${modelName}/${id}/annotations/`,
    params?.toString() || '',
  ]
    .filter((v) => v)
    .join('?')
  try {
    const { status, data } = await get(fetchAnnotUrl)
    if (status === 200) annotations = data.results
  } catch (e) {
    console.error(`Error fetching annotations for record ${id}`, e)
  }
  return annotations
}
